/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminModulesRouteImport } from './routes/admin/modules'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as MigrationsIndexRouteImport } from './routes/migrations/index'
import { Route as MigrationsMigrationIdRouteImport } from './routes/migrations/$migrationId'
import { Route as MigrationsMassRouteImport } from './routes/migrations/mass'
import { Route as MigrationsNewRouteImport } from './routes/migrations/new'
import { Route as ToolsAmplifyOrgRouteImport } from './routes/tools/amplify-org'
import { Route as ToolsBridgeAnalysisRouteImport } from './routes/tools/bridge-analysis'
import { Route as MigrationsBatchesBatchIdRouteImport } from './routes/migrations/batches/$batchId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModulesRoute = AdminModulesRouteImport.update({
  id: '/admin/modules',
  path: '/admin/modules',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationsIndexRoute = MigrationsIndexRouteImport.update({
  id: '/migrations/',
  path: '/migrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationsMigrationIdRoute = MigrationsMigrationIdRouteImport.update({
  id: '/migrations/$migrationId',
  path: '/migrations/$migrationId',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationsMassRoute = MigrationsMassRouteImport.update({
  id: '/migrations/mass',
  path: '/migrations/mass',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationsNewRoute = MigrationsNewRouteImport.update({
  id: '/migrations/new',
  path: '/migrations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAmplifyOrgRoute = ToolsAmplifyOrgRouteImport.update({
  id: '/tools/amplify-org',
  path: '/tools/amplify-org',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsBridgeAnalysisRoute = ToolsBridgeAnalysisRouteImport.update({
  id: '/tools/bridge-analysis',
  path: '/tools/bridge-analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationsBatchesBatchIdRoute =
  MigrationsBatchesBatchIdRouteImport.update({
    id: '/migrations/batches/$batchId',
    path: '/migrations/batches/$batchId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/modules': typeof AdminModulesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/migrations/$migrationId': typeof MigrationsMigrationIdRoute
  '/migrations/mass': typeof MigrationsMassRoute
  '/migrations/new': typeof MigrationsNewRoute
  '/tools/amplify-org': typeof ToolsAmplifyOrgRoute
  '/tools/bridge-analysis': typeof ToolsBridgeAnalysisRoute
  '/migrations/': typeof MigrationsIndexRoute
  '/migrations/batches/$batchId': typeof MigrationsBatchesBatchIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/modules': typeof AdminModulesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/migrations/$migrationId': typeof MigrationsMigrationIdRoute
  '/migrations/mass': typeof MigrationsMassRoute
  '/migrations/new': typeof MigrationsNewRoute
  '/tools/amplify-org': typeof ToolsAmplifyOrgRoute
  '/tools/bridge-analysis': typeof ToolsBridgeAnalysisRoute
  '/migrations': typeof MigrationsIndexRoute
  '/migrations/batches/$batchId': typeof MigrationsBatchesBatchIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/modules': typeof AdminModulesRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/migrations/$migrationId': typeof MigrationsMigrationIdRoute
  '/migrations/mass': typeof MigrationsMassRoute
  '/migrations/new': typeof MigrationsNewRoute
  '/tools/amplify-org': typeof ToolsAmplifyOrgRoute
  '/tools/bridge-analysis': typeof ToolsBridgeAnalysisRoute
  '/migrations/': typeof MigrationsIndexRoute
  '/migrations/batches/$batchId': typeof MigrationsBatchesBatchIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin/audit'
    | '/admin/modules'
    | '/admin/settings'
    | '/admin/users'
    | '/migrations/$migrationId'
    | '/migrations/mass'
    | '/migrations/new'
    | '/tools/amplify-org'
    | '/tools/bridge-analysis'
    | '/migrations/'
    | '/migrations/batches/$batchId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/audit'
    | '/admin/modules'
    | '/admin/settings'
    | '/admin/users'
    | '/migrations/$migrationId'
    | '/migrations/mass'
    | '/migrations/new'
    | '/tools/amplify-org'
    | '/tools/bridge-analysis'
    | '/migrations'
    | '/migrations/batches/$batchId'
  id:
    | '__root__'
    | '/'
    | '/admin/audit'
    | '/admin/modules'
    | '/admin/settings'
    | '/admin/users'
    | '/migrations/$migrationId'
    | '/migrations/mass'
    | '/migrations/new'
    | '/tools/amplify-org'
    | '/tools/bridge-analysis'
    | '/migrations/'
    | '/migrations/batches/$batchId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminModulesRoute: typeof AdminModulesRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  MigrationsMigrationIdRoute: typeof MigrationsMigrationIdRoute
  MigrationsMassRoute: typeof MigrationsMassRoute
  MigrationsNewRoute: typeof MigrationsNewRoute
  ToolsAmplifyOrgRoute: typeof ToolsAmplifyOrgRoute
  ToolsBridgeAnalysisRoute: typeof ToolsBridgeAnalysisRoute
  MigrationsIndexRoute: typeof MigrationsIndexRoute
  MigrationsBatchesBatchIdRoute: typeof MigrationsBatchesBatchIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/modules': {
      id: '/admin/modules'
      path: '/admin/modules'
      fullPath: '/admin/modules'
      preLoaderRoute: typeof AdminModulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrations/': {
      id: '/migrations/'
      path: '/migrations'
      fullPath: '/migrations/'
      preLoaderRoute: typeof MigrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrations/$migrationId': {
      id: '/migrations/$migrationId'
      path: '/migrations/$migrationId'
      fullPath: '/migrations/$migrationId'
      preLoaderRoute: typeof MigrationsMigrationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrations/mass': {
      id: '/migrations/mass'
      path: '/migrations/mass'
      fullPath: '/migrations/mass'
      preLoaderRoute: typeof MigrationsMassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrations/new': {
      id: '/migrations/new'
      path: '/migrations/new'
      fullPath: '/migrations/new'
      preLoaderRoute: typeof MigrationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/amplify-org': {
      id: '/tools/amplify-org'
      path: '/tools/amplify-org'
      fullPath: '/tools/amplify-org'
      preLoaderRoute: typeof ToolsAmplifyOrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/bridge-analysis': {
      id: '/tools/bridge-analysis'
      path: '/tools/bridge-analysis'
      fullPath: '/tools/bridge-analysis'
      preLoaderRoute: typeof ToolsBridgeAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migrations/batches/$batchId': {
      id: '/migrations/batches/$batchId'
      path: '/migrations/batches/$batchId'
      fullPath: '/migrations/batches/$batchId'
      preLoaderRoute: typeof MigrationsBatchesBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminModulesRoute: AdminModulesRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  MigrationsMigrationIdRoute: MigrationsMigrationIdRoute,
  MigrationsMassRoute: MigrationsMassRoute,
  MigrationsNewRoute: MigrationsNewRoute,
  ToolsAmplifyOrgRoute: ToolsAmplifyOrgRoute,
  ToolsBridgeAnalysisRoute: ToolsBridgeAnalysisRoute,
  MigrationsIndexRoute: MigrationsIndexRoute,
  MigrationsBatchesBatchIdRoute: MigrationsBatchesBatchIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
